import { useCallback, useEffect, useState } from 'react';

import { fetchPartenairesSponsors } from '../services/academiaApprenantService';

/**
 * Partenaires et sponsors visibles sur la page d'accueil publique.
 */
export function usePublicPartenairesSponsors() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    setError(false);
    setLoading(true);
    try {
      const rows = await fetchPartenairesSponsors();
      setItems(Array.isArray(rows) ? rows : []);
    } catch {
      setError(true);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const partenaires = items.filter((row) => row.categorie === 'PARTENAIRE');
  const sponsors = items.filter((row) => row.categorie === 'SPONSOR');

  return { items, partenaires, sponsors, loading, error, reload: load };
}
